import React, { useState, useEffect, useMemo } from 'react';
import Translations from "../../services/translation.service";
import StorefrontTitle from '../shared/storefront-title.component';
import hintImg from "../../assets/img/hint.svg";
import Settings from '../../services/settings.service';
import FieldValidity from '../../services/fieldValidity.service';
import ReCAPTCHA from 'react-google-recaptcha';
import PhoneTick from "../../assets/img/PhoneTick.svg";
import PhoneTickX from "../../assets/img/PhoneWrong.svg";
import SharedPhone from '../shared/sharedFields/phone';
import Storage from '../../services/storage.service';
import Helpers from '../../helpers/shared.helper';
import PhoneCalling from "../../assets/img/PhoneCalling.svg";
import SpinnerTimeLoader from '../shared/timeLoading';
import SimDeactivationService from '../../services/sim-deactivation.service';
import EligibilityService from '../../services/eligibility.service';
import FieldSkeleton from '../skeleton/field-skeleton.component';
import Select, { components } from "react-select";
import SelectCheckIcon from "../../assets/img/SelectCheck.svg";
import SelectDownArrowIcon from "../../assets/img/SelectDropDownBlank.svg";
import SharedPhoneKeyPress from '../shared/sharedFields/phone-key-press';

let subscriptions = []
const SimDeactivationForm = ({ props }) => {
    const [captchaChecked, setCaptchaChecked] = useState(false);
    const [mainFormLoader, setMainFormLoader] = useState(false);
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );

    const [formValues, setFormValues] = useState({
        submitLoader: false,
        showNextStepButton: false,
        nextStep: false,
        // Prepaid, 5G Plans Deactivation Fields
        enablePostpaidDeactivation: false,
        phone: {
            phoneCode: Settings?.country,
            value: "",
            touched: false,
            valid: false,
            validation: {
                required: true,
                phoneNumber: true,
                minLength: true,
                minLengthValue: 7,
                maxLength: true,
                maxLengthValue: 10,
            }
        },
        // ID Type for Prepaid/Postpaid
        idTypeLoading: false,
        idTypeOptions: [],
        idType: {
            value: null,
            valid: true,
            touched: false,
        },
        // ID Number for Prepaid/Postpaid
        idNumber: {
            value: "",
            valid: false,
            touched: false
        },
        // Deavtivation Reason for Prepaid/Postpaid
        deactivationReasonLoading: false,
        deactivationReasonOptions: [],
        deactivationReason: {
            value: null,
            valid: true,
            touched: false,    
        },
        // Additional Fields for Postpaid Plan Deactivation Fields
        isPostpaid: false,
        IBAN: {
            value: "",
            valid: false,
            touched: false,
            errorMsg: "",
        },
        contact: {
            phoneCode: Settings?.country,
            value: "",
            touched: false,
            valid: false,
            validation: {
                required: true,
                phoneNumber: true,
                minLength: true,
                minLengthValue: 7,
                maxLength: true,
                maxLengthValue: 10,
            }
        }
    });

    const IconOption = props => (
        <components.Option {...props}>
          {props.isSelected ?
            <div className="react-select-custom-option">
              {props.data.label}
              <img src={SelectCheckIcon} alt=""/>
            </div>
          : 
            <div className="react-select-custom-option">
              {props.data.label}
            </div>
          }
        </components.Option>
    );

    const MenuContainer = props => (
        <components.Menu {...props}>
        <div className="react-select-custom-option-container">
          {props.children}
        </div>
      </components.Menu>
    );

    const DropdownIndicator = () => {
        return <img src={SelectDownArrowIcon} alt=""/>
    }
    

    useEffect(() => {
        const phoneMaxLength = Helpers.getPOValue("top_up_number_length", 10);
        const enablePostpaidDeactivation = Helpers.getPOValue("sim_deactivation_enabled_for_postpaid", false)
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                validation: {
                    ...prevState.phone.validation,
                    maxLengthValue: phoneMaxLength
                }
            },
            contact: {
                ...prevState.contact,
                validation: {
                    ...prevState.contact.validation,
                    maxLengthValue: phoneMaxLength
                }
            },
            nextStep: false,
            enablePostpaidDeactivation: enablePostpaidDeactivation
        }));
    }, [])

    useEffect(() => {
        subscriptions.push(
            Storage.get_obsrv("languageUpdated").subscribe(data => {
                if (data) {
                    fetchIDTypes();
                } 
            })
        );

        const stepsDetails = {
            step1: {
              status: "inProgress",
            },
            step2: {
              status: "notVisited",
            },
            step3: {
              status: "notVisited",
            }
        };
        Storage.set("act_step_detail", stepsDetails);

        subscriptions.push(
            Translations.getKeysObsrv().subscribe((data) => {
                setTranslationsKeys(data);
            })
        );
        return () => {
            if (subscriptions && subscriptions?.length) {
                for (let subscription of subscriptions) {
                    subscription.unsubscribe();
                }
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    const updateContactInput = (phoneObj) => {
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                value: phoneObj.value,
            },
            nextStep: false,
            isPostpaid: false,
            showNextStepButton: false
        }));
    }

    const updateContactField = (phoneObj) => {
        Storage.clear("postpaid_sim_deactivation");
        Storage.clear("genericOTPError");
        setFormValues(prevState => ({
            ...prevState,
            phone: {
                ...prevState.phone,
                value: phoneObj.value,
                valid: phoneObj.valid,
                touched: phoneObj.touched,
                error: phoneObj.error,
                isPostpaid: false
            },
        }));
        if(phoneObj.valid && phoneObj.touched) {
            setFormValues(prevState => ({
                ...prevState,
                submitLoader: true,
            }));
            let countryCode = Helpers.getCountryCodePO() || "";
            let data = {
                number: `${countryCode}${phoneObj?.value?.replace(/^0+/, '')}`,
            }
            Storage.set("genericOTPError", true, true);
            SimDeactivationService.checkNumberType(data)
            .then(response => {
                Storage.set("genericOTPError", true, true);
                if(response.data) {
                    let isPostpaid = false;
                    fetchIDTypes();
                    if(response.data.MSISDNType === "Postpaid") {
                        if(formValues.enablePostpaidDeactivation) {
                            isPostpaid = true;
                            Storage.set("postpaid_sim_deactivation", true)
                            const stepsDetails = {
                                step1: {
                                    // Number
                                    // Prepaid & Postpaid
                                  status: "inProgress",
                                },
                                step2: {
                                    // OTP
                                    // Postpaid Only
                                  status: "notVisited",
                                },
                                step3: {
                                    // Absher
                                    // PrePaid Only
                                  status: "notVisited",
                                },
                                step4: {
                                    // Payment
                                    // Postpaid Only
                                  status: "notVisited",
                                },
                                step5: {
                                    // Confirmation
                                    // Prepaid & Postpaid
                                  status: "notVisited",
                                }
                            };
                            Storage.set("act_step_detail", stepsDetails)
                        } else {
                            setFormValues(prevState => ({
                                ...prevState,
                                nextStep: false,
                                submitLoader: false,
                                phone: {
                                    ...prevState.phone,
                                    valid: false,
                                    error: "postpaid_disabled"
                                },
                            }));
                        }
                    } else {
                        Storage.set("postpaid_sim_deactivation", false)
                        const stepsDetails = {
                            step1: {
                              status: "inProgress",
                            },
                            step2: {
                              status: "notVisited",
                            },
                            step3: {
                              status: "notVisited",
                            }
                        };
                        Storage.set("act_step_detail", stepsDetails);
                    }
                    setFormValues(prevState => ({
                        ...prevState,
                        nextStep: true,
                        submitLoader: false,
                        isPostpaid: isPostpaid
                    }));
                } else {
                    setFormValues(prevState => ({
                        ...prevState,
                        nextStep: false,
                        submitLoader: false,
                        phone: {
                            ...prevState.phone,
                            valid: false,
                            error: "failed"
                        },
                    }));
                }
            })
            .catch((error) => {
                setFormValues(prevState => ({
                    ...prevState,
                    nextStep: false,
                    submitLoader: false,                    
                    phone: {
                        ...prevState.phone,
                        valid: false,
                        error: error?.response?.data?.code
                    },
                }));
            });
        }
    }

    const callPostPaidAPIs = () => {
        setFormValues(prevState => ({
            ...prevState,
            deactivationReasonLoading: true,
        }));
        SimDeactivationService.getPostPaidDeactivationReasons()
        .then(response => {
            if(response?.data){
                let apiResponse = response?.data;
                const reasons = apiResponse?.Reasones;
                if(reasons) {
                    let localStatuses = [];
                    for (const item of reasons) {
                      localStatuses.push({
                        value: item,
                        label: Translations.keys[`deactivation_reason_${Helpers.updateAPIString(item)}`] || item
                      });
                    }
                    setFormValues(prevState => ({
                        ...prevState,
                        deactivationReasonOptions: localStatuses,
                        deactivationReasonLoading: false
                    }));
                }
            }
        })
        .catch(() => {
            setFormValues(prevState => ({
                ...prevState,
                deactivationReasonLoading: false,
            }));
        });
    }

    const callPrePaidAPIs = () => {
        setFormValues(prevState => ({
            ...prevState,
            deactivationReasonLoading: true,
        }));
        SimDeactivationService.getPrePaidDeactivationReasons()
        .then(response => {
            if (response.data && response.data.Reasons) {
                const reasons = response.data.Reasons;
                let localStatuses = [];
                for (const item of reasons) {
                  localStatuses.push({
                    value: item?.Id,
                    label: Translations.keys[`deactivation_reason_${item.Id}`] || item.Name
                  });
                }
                setFormValues(prevState => ({
                    ...prevState,
                    deactivationReasonOptions: localStatuses,
                    deactivationReasonLoading: false
                }));
            }
        })
        .catch(() => {
            setFormValues(prevState => ({
                ...prevState,
                deactivationReasonLoading: false,
            }));
        });
    }

    const fetchIDTypes = () => {
        // Common for PrePaid & PostPaid
        setFormValues(prevState => ({
            ...prevState,
            idTypeLoading: true,
        }));
        EligibilityService.idType()
        .then(response => {
            if(response?.data){
                let business = Storage.get("business", true);
                let eligibility_id_types = null;
                let productType = "Regular";
                if(formValues.isPostpaid) {
                    productType = "RegularPostPaid";
                }
                if (business) {
                    business = JSON.parse(business);
                    eligibility_id_types = business?.eligibility_id_types
                }
                let apiResponse = response.data;
                if(apiResponse.length > 0) {
                    let productCode = Helpers.getProductCode(productType);
                    let matchedObject = eligibility_id_types.find(item => String(item.product_code) === String(productCode));
                    // If no match is found, return the object with "all"
                    if (!matchedObject) {
                      matchedObject = eligibility_id_types.find(item => item.product_code === "all");
                    }
                    const filteredResponse = apiResponse.filter(item => matchedObject?.id_types.includes(item.Id));                    
                    let localStatuses = [];
                    for (const item of filteredResponse) {
                      localStatuses.push({
                        value: item?.Id,
                        label: Translations.keys[`id_type_${item.Id}`] || Translations.activeLang === "en" ? item.Type : item.Type
                      });
                    }
                    setFormValues(prevState => ({
                        ...prevState,
                        idTypeOptions: localStatuses,
                        idTypeLoading: false
                    }));
                }
            }
        })
        .catch(() => {
            setFormValues(prevState => ({
                ...prevState,
                idTypeLoading: false,
            }));
        });
    }

    const convertError = (error) => {
        let errorCode = Math.abs(error);
        return errorCode ? `stm_sim_deactivation_phone_error_${errorCode}` : "stm_sim_deactivation_phone_error_general";
    }

    const handleNextClick = (type) => {
        if(type) {
            callPostPaidAPIs();
        } else {
            callPrePaidAPIs();
        }
        setFormValues(prevState => ({
            ...prevState,
            showNextStepButton: true
        }));
    }

    const updateIDType = event => {
        if (event.value === "0") {
        setFormValues(prevState => ({
            ...prevState,
            idType: {
                ...prevState.idType,
                value: null,
                valid: false,
                touched: true,
            },
        }));
        } else {
            setFormValues(prevState => ({
                ...prevState,
                idType: {
                    ...prevState.idType,
                    value: event.value,
                    valid: true,
                    touched: true,
                    },
            }));
        }
    };

    const updateDeactivationReason = event => {
        if (event.value === "0") {
        setFormValues(prevState => ({
            ...prevState,
            deactivationReason: {
                ...prevState.deactivationReason,
                value: null,
                valid: false,
                touched: true,
            },
        }));
        } else {
            setFormValues(prevState => ({
                ...prevState,
                deactivationReason: {
                    ...prevState.deactivationReason,
                    value: event.value,
                    valid: true,
                    touched: true,
                    },
            }));
        }
    };

    const updateIdNumber = (event) => {
        if (event.target) {
            const { name, value } = event.target;
            if (Helpers.isValidIDNumber(event.target.value)) {
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: {
                        ...prevState[name],
                        value,
                        valid: true,
                        touched: true
                    }
                }));
            } else {
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: {
                        ...prevState[name],
                        value,
                        valid: false,
                        touched: true
                    }
                }));
            }
        }
    }

    const updateIBANaccount = (event) => {
        if (event.target) {
            const { name, value } = event.target;
            if (!Helpers.isValidIBAN(event.target.value)) {
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: {
                        ...prevState[name],
                        value,
                        valid: true,
                        touched: true
                    }
                }));
            } else {
                setFormValues(prevState => ({
                    ...prevState,
                    [name]: {
                        ...prevState[name],
                        value,
                        valid: false,
                        touched: true
                    }
                }));
            }
        }
    }

    const updateContactPhoneField = (phoneObj) => {
        setFormValues(prevState => ({
            ...prevState,
            contact: {
                ...prevState.contact,
                value: phoneObj.value,
                valid: phoneObj.valid,
                touched: phoneObj.touched,
                error: phoneObj.error
            },
        }));
    }
    
    const handleMainFormSubmit = () => {
        setMainFormLoader(true);
        if(formValues.isPostpaid) {
            Storage.set("postpaid_sim_deactivation", true, true);
        } else {
            Storage.clear("postpaid_sim_deactivation");    
        }
        let data = null;
        let countryCode = Helpers.getCountryCodePO() || ""; 
        let phoneNumber = formValues.phone.value
        phoneNumber = `${countryCode}${phoneNumber?.replace(/^0+/, '')}`;    
        data = {
            number: phoneNumber,
            reason_id: formValues.deactivationReason.value,
            id_number: formValues.idNumber.value,
            id_type: formValues.idType.value,
        }
        SimDeactivationService.requestOTPForWeb(data)
        .then(response => {
            if (response.data) {
                props.history.push({
                    pathname: '/sim-deactivation/otp',
                    state: { formValues: formValues }
                });
                setMainFormLoader(false);
            }
        })
        .catch(() => {
        });
    }

    const updateCaptcha = (value) => {
        if (value) {
            setCaptchaChecked(true);
        } else {
            setCaptchaChecked(false);
        }
    }

    const checkIfFormValid = () => {
        const { phone, idType, idNumber, deactivationReason, IBAN, contact, isPostpaid } = formValues;
    
        // Common validation checks
        const isCommonValid = phone.valid && phone.touched &&
                              idType.valid && idType.touched &&
                              idNumber.valid && idNumber.touched &&
                              deactivationReason.valid && deactivationReason.touched 
                              && captchaChecked;
    
        if (isPostpaid) {
            return !isCommonValid || !IBAN.valid || !IBAN.touched || !contact.valid || !contact.touched;
        } else {
            return !isCommonValid;
        }
    }

    const isFormValid = useMemo(() => checkIfFormValid(), [formValues, captchaChecked]); // eslint-disable-line react-hooks/exhaustive-deps
    
    const staticLanguageLink = (link, linkAR) => {
        if (Translations.activeLang === "en") {
          return link;
        }
        if (Translations.activeLang === "ar") {
          return linkAR;
        }
        return "#";
      };

    return (
        <>
            <div className="generic-form-container generic-bill-payment-form-container">
                <StorefrontTitle
                    title={translationKeys["scr_15.0_Sim_Deactivation_title"]}
                    desc={translationKeys["scr_15.0_Sim_Deactivation_form_title"]}
                />
                {mainFormLoader ? <SpinnerTimeLoader /> :
                <div className="field-section">
                    <div className="field-container">
                        <label>{translationKeys["stm_sim_deactivation_phone_number"]}</label>
                        <div className="phone-field-with-tick">
                            <SharedPhone
                                name="phone"
                                id="phone"
                                classname="storefront-phone-field tickIcon phoneIcon"
                                phone={formValues?.phone}
                                updateContactField={updateContactField}
                                updateContactInput={(e) => updateContactInput(e)}
                                placeholder={translationKeys["stm_sim_deactivation_phone_placeholder"] || "05X XXX XXXX"}
                            />
                            <img src={PhoneCalling} className="imgLeft" alt=""/>
                            {formValues.phone.touched && <img className="imgRight" src={formValues.phone.valid ? PhoneTick : PhoneTickX} alt=""/>}
                        </div>
                        {formValues.phone.error && !formValues.phone.valid ? <span className="error-msg" title={convertError(formValues.phone.error)}>{translationKeys[convertError(formValues.phone.error)] || "Please enter valid number"}</span> : ""}
                        <div className="hint-section">
                            <img src={hintImg} alt="Message" />
                            <p>{translationKeys["stm_sim_deactivation_asso_phone_number"]}</p>
                        </div>
                    </div>

                    {formValues.phone.valid && formValues.nextStep && formValues.showNextStepButton ?
                    <>
                        <div className="field-container">
                            <label>{translationKeys["scr_15.0_Sim_Deactivation_id_type"]}</label>
                                {formValues.idTypeLoading ? <FieldSkeleton /> :
                                    <Select
                                        unstyled
                                        className="react-select-custom"
                                        placeholder={Translations.keys["stm_sim_deactivation_choose_id_type"] || "Choose ID Type"}
                                        isSearchable={false}
                                        name="idType"
                                        options={formValues.idTypeOptions}
                                        components={{ Option: IconOption, Menu: MenuContainer, DropdownIndicator: DropdownIndicator }}
                                        onChange={(e) => {
                                            updateIDType(e);
                                        }}
                                        value={formValues.idTypeOptions?.filter(option => 
                                            option.value === formValues.idType.value
                                        )}
                                        defaultValue={formValues.idTypeOptions?.filter(option => 
                                            option.value === formValues.idType.value
                                        )}
                                    />
                                }
                        </div>

                        <div className="field-container">
                            <label>{translationKeys["scr_15.0_Sim_Deactivation_id_number"]}</label>
                            <input
                                className={
                                    "storefront-search-input " +
                                    (!formValues.idNumber.touched || (formValues.idNumber.touched && formValues.idNumber.valid)
                                        ? "valid"
                                        : "invalid") +
                                    (formValues.idNumber.value ? " filled" : "")
                                }
                                autoComplete="off"
                                type="text"
                                name="idNumber"
                                id="idNumber"
                                require="true"
                                value={formValues.idNumber.value}
                                onChange={(e) => {
                                    if (FieldValidity.numberOnly(e)) {
                                        updateIdNumber(e)
                                    }
                                }}
                                placeholder={Translations.keys["stm_sim_deactivation_enter_id_number"] || "Enter ID number"}
                            />
                        </div>

                        <div className="field-container">
                            <label>{translationKeys["scr_15.0_Sim_Deactivation_reason"]}</label>
                                {formValues.deactivationReasonLoading ? <FieldSkeleton /> :
                                    <Select
                                        unstyled
                                        className="react-select-custom"
                                        placeholder={Translations.keys["stm_sim_deactivation_choose_reason"] || "Choose Reason"}
                                        isSearchable={false}
                                        name="deactivationReason"
                                        options={formValues.deactivationReasonOptions}
                                        components={{ Option: IconOption, Menu: MenuContainer, DropdownIndicator: DropdownIndicator }}
                                        onChange={(e) => {
                                            updateDeactivationReason(e);
                                        }}
                                        value={formValues.deactivationReasonOptions?.filter(option => 
                                            option.value === formValues.deactivationReason.value
                                        )}
                                        defaultValue={formValues.deactivationReasonOptions?.filter(option => 
                                            option.value === formValues.deactivationReason.value
                                        )}
                                    />
                                }
                        </div>

                        {formValues.isPostpaid ?
                        <div className="field-container">
                            <label>{Translations.keys["stm_sim_deactivation_iban"] || "IBAN"}</label>
                            <input
                                className={
                                    "storefront-search-input " +
                                    (!formValues.IBAN.touched || (formValues.IBAN.touched && formValues.IBAN.valid)
                                        ? "valid"
                                        : "invalid") +
                                    (formValues.IBAN.value ? " filled" : "")
                                }
                                autoComplete="off"
                                type="text"
                                name="IBAN"
                                id="IBAN"                
                                require="true"
                                value={formValues.IBAN.value}
                                onChange={(e) => {
                                    if(Helpers.inputAlphaNumeric(e, 34)) {
                                        updateIBANaccount(e);
                                    }
                                }}
                                placeholder={Translations.keys["stm_sim_deactivation_enter_iban"] || "Enter IBAN"}
                            />

                            <div className="hint-section">
                                <img src={hintImg} alt="Message" />
                                <p>{Translations.keys["stm_sim_deactivation_iban_hint"]}</p>
                            </div>
                        </div> : ""}

                        {formValues.isPostpaid ?
                            <div className="field-container">
                                <label>{translationKeys["scr_15.0_Sim_Deactivation_contact_number"]}</label>
                                <div className="phone-field-with-tick">
                                    <SharedPhoneKeyPress 
                                        name="contact"
                                        id="contact"
                                        classname="storefront-phone-field tickIcon phoneIcon"
                                        phone={formValues?.contact}
                                        updateContactField={updateContactPhoneField}
                                        placeholder={translationKeys["stm_sim_deactivation_phone_placeholder"] || "05X XXX XXXX"}
                                    />
                                    <img src={PhoneCalling} className="imgLeft" alt=""/>
                                    {formValues.contact.touched && <img className="imgRight" src={formValues.contact.valid ? PhoneTick : PhoneTickX} alt=""/>}
                                </div>
                                {formValues.contact.error && !formValues.contact.valid ? <span className="error-msg">{translationKeys[convertError(formValues.contact.error)] || "Please enter valid number"}</span> : ""}
                            </div> 
                        : ""}

                        {formValues.isPostpaid ?
                        <div className="field-container">
                            <p className="terms-and-conditions">{translationKeys["stm_sim_deactivation_tc_1"]}<a href={staticLanguageLink(Settings?.footer?.terms_and_conditions, Settings?.footer?.terms_and_conditionsAR)} target="_blank" rel="noopener noreferrer">{translationKeys["stm_sim_deactivation_tc_2"]}</a></p>
                        </div> : ""}

                        <div className="field-container">
                            <ReCAPTCHA
                                sitekey={Settings.get("google_recaptcha_site_key")}
                                onChange={updateCaptcha}
                            />
                        </div>
                    </> : null}

                    {formValues.submitLoader ?
                        <SpinnerTimeLoader /> 
                        :
                        <>
                        {!formValues.showNextStepButton ?
                            // Button for Moving to the Main Form.
                            <button
                                className={"common-button"}
                                disabled={!formValues.phone.valid || !formValues.phone.touched || !formValues.nextStep}
                                onClick={() => {
                                    handleNextClick(formValues.isPostpaid);
                                }}
                            >
                               {translationKeys["stm_sim_deactivation_next"] || "Next"} 
                            </button> :
                            // Button for Submitting the Main Form.
                            <button
                                className={"common-button"}
                                disabled={isFormValid}
                                onClick={() => {
                                    handleMainFormSubmit();
                                }}
                            >
                                {translationKeys["stm_sim_deactivation_next"] || "Next"}
                            </button>
                        }
                    </>}
                </div>}
            </div>
        </>

    )
}

export default SimDeactivationForm;